import http from '../common/http';
import env from '../envConfig';
import { getHeader, getHeaderRotasAbertas } from '../auth/authManager';
import { responseHandler } from '../common/responseHandler';

export const obterConfiguracaoParametro = async (
  chaveConfiguracao: string,
) => {
  let url = env.urlApi + `/transacional-api/v1/suporte/configuracao/chave/${chaveConfiguracao}`;
  const headers = getHeaderRotasAbertas();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterDecursoDePrazo = async () => {
  let url = env.urlApi + `/transacional-api/v1/suporte/configuracao/decursoPrazo`;
  const headers = getHeaderRotasAbertas();

  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterToken = async () => {
  let url = env.urlApi + `/transacional-api/v1/suporte/configuracao/token`;
  const headers = getHeader();

  const response = await http.get(url, { headers });
  return responseHandler(response);
};
